import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  label: {
    padding: 0,
  },
}));

export default useStyles;
